import { createContext } from 'react';
import Api from '../../services/api/api';

const AppContext = createContext({
  api: new Api(),
});

export default AppContext;
